<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
      /></v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        :no-data-text="$t('messages.information.no_data')"
        :headers="headers"
        :items="inspections"
        :search="search"
        item-text="text"
        :loading-text="$t('categories.inspection.loading')"
        :no-results-text="$tc('categories.inspection.name', 0)"
        :loading="loading"
        disable-pagination
        hide-default-footer
        @dblclick:row="($event, { item }) => handleInspectionEdit(item)"
      >
        <template v-slot:item.start_date="{ item }">
          {{ toDatetime(item.start_date) }}
        </template>
        <template v-slot:item.end_date="{ item }">
          {{ toDatetime(item.end_date) }}
        </template>
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item)" />
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-webcamButton
              :disabled="isInspectionOver(item)"
              @click.stop="handleInspectionJoin(item)"
              :spantext="
                $t('actions.join', { entity: $tc('categories.inspection.name', 1).toLowerCase() })
              "
            />
            <avs-editButton
              @click.stop="handleInspectionEdit(item)"
              :spantext="
                $t('actions.edit', { entity: $tc('categories.inspection.name', 1).toLowerCase() })
              "
            />
            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', {
                  entity: $tc('categories.inspection.name', 1).toLowerCase()
                })
              "
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="inspection"
      />
    </template>
  </avs-card>
</template>

<script>
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { InspectionService, ProjectService } from "@/services"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "AllInspections",
  components: { Closed, Ongoing, Overdue, Pending },
  data() {
    return {
      deleteDialogIsOpen: false,
      headers: [
        { text: "Company", value: "company.name", class: "min-width-200" },
        { text: "Project", value: "project.name", class: "min-width-200" },
        { text: "Inspection", value: "name", class: "min-width-200" },
        { text: "Start date", value: "start_date", class: "min-width-150" },
        { text: "End date", value: "end_date", class: "min-width-150" },
        { text: "Status", align: "center", value: "status" },
        { text: "Actions", sortable: false, value: "actions", align: "right", width: 150 }
      ],
      inspections: [],
      loading: false,
      search: "",
      selectedItem: null
    }
  },
  created() {
    this.getAllInspections()
  },
  methods: {
    getAllInspections() {
      this.loading = true
      InspectionService.getAllInspections().then(response => {
        this.inspections = response
        this.loading = false
      })
    },
    handleStatusComponent(item) {
      return item.status
    },
    async setStoreFromProjectId(projectId) {
      return ProjectService.get(this, null, projectId).then(project => {
        this.$store.commit("app/setCompany", project.company)
        this.$store.commit("app/setProject", project)
      })
    },
    async handleInspectionEdit(item) {
      this.setStoreFromProjectId(item.project.id).then(() => {
        this.$router.push({ name: "Inspection", params: { id: item.id } })
      })
    },
    async handleInspectionJoin(item) {
      this.setStoreFromProjectId(item.project.id).then(() => {
        this.$router.push({ name: "InspectionMeeting", params: { id: item.id, uuid: item.uuid } })
      })
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete(item) {
      InspectionService.remove(this, this.selectedItem.id).then(r => {
        this.inspections = this.inspections.filter(nc => nc.id !== this.selectedItem.id)
        let message = this.$t("messages.success.deleted", {
          entity: this.$tc("categories.inspection.name", 1)
        })
        this.notify(message, "success")
      })
      this.deleteDialogIsOpen = false
    },
    notify(message, color) {
      this.$store.commit("app/message", { msg: message, color: color })
    },
    isInspectionOver(item) {
      return ["Closed", "Overdue"].includes(item.status)
    },
    toDatetime
  }
}
</script>
